/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CardTypeDTO,
    CardTypeDTOFromJSON,
    CardTypeDTOFromJSONTyped,
    CardTypeDTOToJSON,
} from './CardTypeDTO';
import {
    CarePrincipalDTO,
    CarePrincipalDTOFromJSON,
    CarePrincipalDTOFromJSONTyped,
    CarePrincipalDTOToJSON,
} from './CarePrincipalDTO';
import {
    ExportStatusDTO,
    ExportStatusDTOFromJSON,
    ExportStatusDTOFromJSONTyped,
    ExportStatusDTOToJSON,
} from './ExportStatusDTO';
import {
    PersonDTO,
    PersonDTOFromJSON,
    PersonDTOFromJSONTyped,
    PersonDTOToJSON,
} from './PersonDTO';
import {
    TransactionDTO,
    TransactionDTOFromJSON,
    TransactionDTOFromJSONTyped,
    TransactionDTOToJSON,
} from './TransactionDTO';

/**
 * 
 * @export
 * @interface ExtendedCardDTO
 */
export interface ExtendedCardDTO {
    /**
     * 
     * @type {string}
     * @memberof ExtendedCardDTO
     */
    cardSystemId?: string;
    /**
     * 
     * @type {CardTypeDTO}
     * @memberof ExtendedCardDTO
     */
    cardType?: CardTypeDTO;
    /**
     * 
     * @type {Array<PersonDTO>}
     * @memberof ExtendedCardDTO
     */
    persons?: Array<PersonDTO>;
    /**
     * 
     * @type {Date}
     * @memberof ExtendedCardDTO
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExtendedCardDTO
     */
    preliminaryCardDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExtendedCardDTO
     */
    finalCardDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExtendedCardDTO
     */
    endDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof ExtendedCardDTO
     */
    currentAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ExtendedCardDTO
     */
    amountToLimit?: number;
    /**
     * 
     * @type {string}
     * @memberof ExtendedCardDTO
     */
    cardId?: string;
    /**
     * 
     * @type {CarePrincipalDTO}
     * @memberof ExtendedCardDTO
     */
    carePrincipal?: CarePrincipalDTO;
    /**
     * 
     * @type {string}
     * @memberof ExtendedCardDTO
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedCardDTO
     */
    registeringCareProviderId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedCardDTO
     */
    cardReason?: ExtendedCardDTOCardReasonEnum;
    /**
     * 
     * @type {Array<TransactionDTO>}
     * @memberof ExtendedCardDTO
     */
    transactions?: Array<TransactionDTO>;
    /**
     * 
     * @type {Array<TransactionDTO>}
     * @memberof ExtendedCardDTO
     */
    expiredTransactions?: Array<TransactionDTO>;
    /**
     * 
     * @type {Array<ExportStatusDTO>}
     * @memberof ExtendedCardDTO
     */
    exportStatus?: Array<ExportStatusDTO>;
}

/**
* @export
* @enum {string}
*/
export enum ExtendedCardDTOCardReasonEnum {
    Validcard = 'VALIDCARD',
    Medical = 'MEDICAL',
    Hks = 'HKS'
}

export function ExtendedCardDTOFromJSON(json: any): ExtendedCardDTO {
    return ExtendedCardDTOFromJSONTyped(json, false);
}

export function ExtendedCardDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtendedCardDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cardSystemId': !exists(json, 'cardSystemId') ? undefined : json['cardSystemId'],
        'cardType': !exists(json, 'cardType') ? undefined : CardTypeDTOFromJSON(json['cardType']),
        'persons': !exists(json, 'persons') ? undefined : ((json['persons'] as Array<any>).map(PersonDTOFromJSON)),
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'preliminaryCardDate': !exists(json, 'preliminaryCardDate') ? undefined : (new Date(json['preliminaryCardDate'])),
        'finalCardDate': !exists(json, 'finalCardDate') ? undefined : (new Date(json['finalCardDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'currentAmount': !exists(json, 'currentAmount') ? undefined : json['currentAmount'],
        'amountToLimit': !exists(json, 'amountToLimit') ? undefined : json['amountToLimit'],
        'cardId': !exists(json, 'cardId') ? undefined : json['cardId'],
        'carePrincipal': !exists(json, 'carePrincipal') ? undefined : CarePrincipalDTOFromJSON(json['carePrincipal']),
        'status': !exists(json, 'status') ? undefined : json['status'],
        'registeringCareProviderId': !exists(json, 'registeringCareProviderId') ? undefined : json['registeringCareProviderId'],
        'cardReason': !exists(json, 'cardReason') ? undefined : json['cardReason'],
        'transactions': !exists(json, 'transactions') ? undefined : ((json['transactions'] as Array<any>).map(TransactionDTOFromJSON)),
        'expiredTransactions': !exists(json, 'expiredTransactions') ? undefined : ((json['expiredTransactions'] as Array<any>).map(TransactionDTOFromJSON)),
        'exportStatus': !exists(json, 'exportStatus') ? undefined : ((json['exportStatus'] as Array<any>).map(ExportStatusDTOFromJSON)),
    };
}

export function ExtendedCardDTOToJSON(value?: ExtendedCardDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cardSystemId': value.cardSystemId,
        'cardType': CardTypeDTOToJSON(value.cardType),
        'persons': value.persons === undefined ? undefined : ((value.persons as Array<any>).map(PersonDTOToJSON)),
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString().substr(0,10)),
        'preliminaryCardDate': value.preliminaryCardDate === undefined ? undefined : (value.preliminaryCardDate.toISOString().substr(0,10)),
        'finalCardDate': value.finalCardDate === undefined ? undefined : (value.finalCardDate.toISOString().substr(0,10)),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString().substr(0,10)),
        'currentAmount': value.currentAmount,
        'amountToLimit': value.amountToLimit,
        'cardId': value.cardId,
        'carePrincipal': CarePrincipalDTOToJSON(value.carePrincipal),
        'status': value.status,
        'registeringCareProviderId': value.registeringCareProviderId,
        'cardReason': value.cardReason,
        'transactions': value.transactions === undefined ? undefined : ((value.transactions as Array<any>).map(TransactionDTOToJSON)),
        'expiredTransactions': value.expiredTransactions === undefined ? undefined : ((value.expiredTransactions as Array<any>).map(TransactionDTOToJSON)),
        'exportStatus': value.exportStatus === undefined ? undefined : ((value.exportStatus as Array<any>).map(ExportStatusDTOToJSON)),
    };
}

